import script from "./ListLogActivity.vue?vue&type=script&lang=ts&setup=true"
export * from "./ListLogActivity.vue?vue&type=script&lang=ts&setup=true"

import "./ListLogActivity.vue?vue&type=style&index=0&id=74815c94&lang=css"

const __exports__ = script;

export default __exports__